export default __webpack_public_path__ + "static/media/tag-fill.5944eb58.svg";